import { render, staticRenderFns } from "./defaultScrollWithoutSidebarLogo.vue?vue&type=template&id=55b10e18&scoped=true"
import script from "./defaultScrollWithoutSidebarLogo.vue?vue&type=script&lang=js"
export * from "./defaultScrollWithoutSidebarLogo.vue?vue&type=script&lang=js"
import style0 from "./defaultScrollWithoutSidebarLogo.vue?vue&type=style&index=0&id=55b10e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b10e18",
  null
  
)

export default component.exports